import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PublicProductDto } from '../../../../api/models/public-product-dto';
import { ProductsMetaService } from '../../../cart/products-meta.service';
import { RoofProductTypeEnum } from '../../../../api/models';

@Component({
  selector: 'price-table',
  templateUrl: './prices-table.component.html',
  styleUrls: ['./prices-table.component.scss'],
})
export class PricesTableComponent implements OnInit {
  @Input()
  products!: EventEmitter<PublicProductDto[]>;
  dataSource = new MatTableDataSource<PublicProductDto>([]);
  displayedColumns = ['imageUrl', 'name', 'producer', 'price'];
  imageBaseUrl = ProductsMetaService.baseImageUrl;

  ngOnInit() {
    this.products.subscribe((products) => {
      this.dataSource = new MatTableDataSource(products);
    });
  }

  getProductNameUrlFriendly(product: PublicProductDto): string {
    return ProductsMetaService.getProductNameUrlFriendly(product.name, product.producer);
  }

  getRouteUrl(product: PublicProductDto): string[] {
    return [
      '../',
      'produse',
      product.type === RoofProductTypeEnum.Tile ? 'tigla-metalica' : 'accesoriu',
      this.getProductNameUrlFriendly(product),
      product.id,
    ];
  }
}
